<template>
  <svg viewBox="0 0 539 525" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <clipPath id="clip-path">
      <circle class="cls-1" cx="130.91" cy="338.18" r="26.47"/>
    </clipPath>
    <clipPath id="clip-path-2">
      <circle class="cls-1" cx="130.91" cy="484.25" r="26.47"/>
    </clipPath>
    <clipPath id="clip-path-3">
      <circle class="cls-1" cx="51.59" cy="182.89" r="32.52"/>
    </clipPath>
    <clipPath id="clip-path-4">
      <circle class="cls-1" cx="223.72" cy="182.89" r="32.52"/>
    </clipPath>
    <clipPath id="clip-path-5">
      <circle class="cls-1" cx="399.26" cy="183.17" r="32.52"/>
    </clipPath>
    <clipPath id="clip-path-6">
      <circle class="cls-1" cx="129.79" cy="265.35" r="32.52"/>
    </clipPath>
    <clipPath id="clip-path-7">
      <circle class="cls-1" cx="219.13" cy="107.97" r="25.65"/>
    </clipPath>
  </defs>
  <g stroke="#043" stroke-miterlimit="10" stroke-width="2">
    <path fill="#043" d="M4.32 7h529.91v65.17H4.32z"/>
    <path fill="#beeb7b" d="M4.32 72.17h529.91v152.79H4.32z"/>
    <path fill="#ffe300" d="M4.32 224.96h529.91v80.68H4.32z"/>
    <path fill="#00dbd7" d="M4.32 371.03h529.91v80.68H4.32z"/>
    <path class="cls-6" fill="#e2e2e2" d="M4.32 304.93h529.91v65.99H4.32zM4.32 451.82h529.91v65.99H4.32z"/>
  </g>
  <text x="230.25" y="45.57" fill="#ffe400" font-family="OpenSans-Bold,Open Sans, helvetica" font-size="20.4" font-weight="700">
    PRODUCCIÓN
  </text>
  <g id="boton1" class="fix-svg-origin hvr hvr-scale" @click="mostrar(1)">
    <circle class="cls-8" cx="195.43" cy="39.58" r="27.48" fill="#fff"/>
    <circle cx="195.43" cy="39.58" r="25.65" fill="#043"/>
    <path class="cls-10" fill="#a59e7f" d="M196.02 57.89l5.62-7.05-5.65-5.56 5.08-5.96-5.45-5.04-.53.57 4.9 4.53-5.07 5.95 5.67 5.57-5.57 6.99z"/>
    <path class="cls-10" fill="#a59e7f" d="M190.31 50.9l5.68-5.57-5.07-5.95 4.9-4.53-.54-.57-5.44 5.04 5.08 5.96-5.66 5.56 5.62 7.05h1z"/>
    <path class="cls-11" fill="#b7ac7e" d="M195.88 51.17l5.46-5.85-5.26-6.33 4.23-4.15-.54-.56-4.75 4.65 5.28 6.36-5.47 5.87 5.88 6.73h1.04z"/>
    <path class="cls-11" fill="#b7ac7e" d="M190.2 57.89l5.88-6.73-5.48-5.87 5.29-6.36-4.75-4.65-.55.56 4.23 4.15-5.26 6.33 5.46 5.85-5.86 6.72z"/>
    <g fill="#ddd19f">
      <path class="cls-12" d="M194.84 29.78h1.17v28.11h-1.17zM199.26 29.82L201 57.89h1.18l-1.75-28.15zM190.67 29.74l-1.75 28.15h1.18l1.74-28.07z"/>
    </g>
    <path class="cls-11" fill="#b7ac7e" d="M189.37 29.78h12.11v1.95h-12.11z"/>
    <path class="cls-12" fill="#ddd19f" d="M191.52 28.61h7.81v1.17h-7.81z"/>
    <path class="cls-11" fill="#b7ac7e" d="M194.34 26.1h2.18v2.5h-2.18zM184.39 57.52h22.07v3.3h-22.07z"/>
    <path d="M199.34 24c0 1.49-1.78 2.69-4 2.69s-4-1.2-4-2.69 2.92-5.67 4-5.67c.74.01 4 4.2 4 5.67z" fill="#ff872e"/>
    <path class="cls-14" d="M198.45 24.62c0 1.15-1.38 2.08-3.08 2.08s-3.08-.93-3.08-2.08 2.26-4.4 3.08-4.4c.55 0 3.08 3.25 3.08 4.4z" fill="#ffe300"/>
  </g>
  <g id="boton7" class="fix-svg-origin hvr hvr-scale" @click="mostrar(7)">
    <circle class="cls-8" cx="130.91" cy="338.18" r="28.36" fill="#fff"/>
    <circle class="cls-15" cx="130.91" cy="338.18" r="26.47" fill="#c3cfd1"/>
    <g clip-path="url(#clip-path)">
      <ellipse class="cls-17" cx="103.01" cy="337.26" rx="2.71" ry="12.39" fill="#a5110e"/>
      <path class="cls-18" d="M133.62 325.91v22.7h-30.15c-1.36 0-2.47-5.08-2.47-11.34s1.11-11.34 2.47-11.34h.06z" fill="#d12118"/>
      <g fill="#a5110e">
        <path class="cls-17" d="M115.05 325.91h-.63c-1.36 0-2.47 5.08-2.47 11.34s1.11 11.34 2.47 11.34h.63c-.33.67-.7 1-1.09 1-1.49 0-2.71-5.55-2.71-12.39s1.22-12.39 2.71-12.39c.39.06.76.43 1.09 1.1zM125.54 325.91h-.6c-1.36 0-2.47 5.08-2.47 11.34s1.11 11.34 2.47 11.34h.63c-.33.67-.7 1-1.09 1-1.49 0-2.71-5.55-2.71-12.39s1.22-12.39 2.71-12.39c.36.06.73.43 1.06 1.1z"/>
        <ellipse class="cls-17" cx="133.67" cy="337.26" rx="2.71" ry="12.39"/>
      </g>
      <ellipse class="cls-19" cx="133.79" cy="337.26" rx="1.79" ry="10.74" fill="#561111"/>
      <path class="cls-20" d="M133.84 348a1.27 1.27 0 0 1 .64.67c.29.57.81 1.72.81 1.72s.31.62-.52.62a5.58 5.58 0 0 0-1.87 0c-.73.21-1.25.21-1.46.42s-.93.83-.2 1 .52.41 1.76.41.32-.62 1.46 0 .21.63 1.77 1a6.08 6.08 0 0 0 2.6.42 16.35 16.35 0 0 0 2.28 0 9.28 9.28 0 0 0 1.56-.52c.94-.31.52-.42 1.46-.31a13.52 13.52 0 0 1 1.45.31c.73.1 1.15.31 1.67.1a12.81 12.81 0 0 1 1.77-.83c.51-.1.51 0 1.35-.1a9.71 9.71 0 0 0 1.87-.52s-.11-.63-.63-.63 0 .31-1.14-.1-1.25-.73-1.87-.73H147c-.42 0-.73.21-1.25-.1s-.62-.94-1.25-.73a10.21 10.21 0 0 1-2.18.21 4.81 4.81 0 0 1-1.35 0 5 5 0 0 1-1.87-.32 18.7 18.7 0 0 0-2.5-.62c-.31-.1-.52 0-.93-.41a9.79 9.79 0 0 1-.75-.85l-.6-.51z" fill="#282828"/>
    </g>
  </g>
  <text class="cls-21" x="163.44" y="344.82" fill="#191919" font-family="OpenSans-Bold, 'Open Sans', helvetica" font-size="20.4" font-weight="700">
    Recursos no recuperables
  </text>
  <g id="boton9" class="fix-svg-origin hvr hvr-scale" @click="mostrar(7)">
    <circle class="cls-8" cx="130.91" cy="484.25" r="28.36" fill="#fff"/>
    <circle class="cls-15" cx="130.91" cy="484.25" r="26.47" fill="#c3cfd1"/>
    <g clip-path="url(#clip-path-2)">
      <ellipse class="cls-17" cx="103.01" cy="483.33" rx="2.71" ry="12.39" fill="#a5110e"/>
      <path class="cls-18" d="M133.62 472v22.71h-30.15c-1.36 0-2.47-5.08-2.47-11.34s1.11-11.37 2.47-11.37h.06z" fill="#d12118"/>
      <g fill="#a5110e">
        <path class="cls-17" d="M115.05 472h-.63c-1.36 0-2.47 5.07-2.47 11.33s1.11 11.34 2.47 11.34h.63c-.33.66-.7 1-1.09 1-1.49 0-2.71-5.54-2.71-12.39s1.22-12.39 2.71-12.39c.39.05.76.42 1.09 1.11zM125.54 472h-.6c-1.36 0-2.47 5.07-2.47 11.33s1.11 11.34 2.47 11.34h.63c-.33.66-.7 1-1.09 1-1.49 0-2.71-5.54-2.71-12.39s1.22-12.39 2.71-12.39c.36.05.73.42 1.06 1.11z"/>
        <ellipse class="cls-17" cx="133.67" cy="483.33" rx="2.71" ry="12.39"/>
      </g>
      <ellipse class="cls-19" cx="133.79" cy="483.33" rx="1.79" ry="10.74" fill="#561111"/>
      <path class="cls-20" d="M133.84 494.07a1.27 1.27 0 0 1 .64.67c.29.58.81 1.72.81 1.72s.31.62-.52.62a5.86 5.86 0 0 0-1.87 0c-.73.21-1.25.21-1.46.42s-.93.83-.2 1 .52.42 1.76.42.32-.63 1.46 0 .21.62 1.77 1a6.21 6.21 0 0 0 2.6.41 16.35 16.35 0 0 0 2.28 0 8.44 8.44 0 0 0 1.56-.52c.94-.31.52-.41 1.46-.31s.73.21 1.45.31 1.15.31 1.67.11a14.18 14.18 0 0 1 1.77-.84c.51-.1.51 0 1.35-.1a9 9 0 0 0 1.87-.52s-.11-.62-.63-.62 0 .31-1.14-.11-1.25-.73-1.87-.73H147c-.42 0-.73.21-1.25-.1s-.62-.94-1.25-.73a10.21 10.21 0 0 1-2.18.21 4.81 4.81 0 0 1-1.35 0 5 5 0 0 1-1.87-.31 19 19 0 0 0-2.5-.63c-.31-.1-.52 0-.93-.41a9.79 9.79 0 0 1-.75-.85l-.6-.5z" fill="#282828"/>
    </g>
  </g>
  <text class="cls-21" x="163.44" y="490.89" fill="#191919" font-family="OpenSans-Bold, 'Open Sans',helvetica" font-size="20.4" font-weight="700">
    Recursos no recuperables
  </text>
  <path class="cls-8" fill="#fff" d="M72.75 172.69h105.27v20.4H72.75z"/>
  <text class="cls-23" x="93.42" y="188.36" font-family="OpenSans-Bold, 'Open Sans',helvetica" font-size="16.32" font-weight="700">
    Probadas
  </text>
  <g id="boton3" class="fix-svg-origin hvr hvr-scale" @click="mostrar(3)">
    <circle class="cls-8" cx="51.59" cy="182.89" r="34.84" fill="#fff"/>
    <circle class="cls-24" cx="51.59" cy="182.89" r="32.52" fill="#beeb7b"/>
    <g clip-path="url(#clip-path-3)">
      <g fill="#2d2d2d">
        <path class="cls-26" d="M52.15 176.78a11.34 11.34 0 0 1 1.92-3.61 8.9 8.9 0 0 1 3.36-2.65l.51-.24.53-.18a7.09 7.09 0 0 1 1.09-.31c.37 0 .75-.09 1.13-.11a6.75 6.75 0 0 1 1.11.16l.55.12.51.21c.33.15.66.3 1 .48a7.14 7.14 0 0 1 1.62 1.43l-.1.21a13.27 13.27 0 0 1-2-.09h-2.74a8.1 8.1 0 0 1-.85 0 4.15 4.15 0 0 0-.86 0h-.43l-.42.12A8.66 8.66 0 0 0 54.9 174a12.67 12.67 0 0 0-2.54 2.9zM51.75 176.46a26.05 26.05 0 0 0-1.63-3.88 16.26 16.26 0 0 0-2.26-3.35 6.47 6.47 0 0 0-1.48-1.16 17 17 0 0 0-1.52-.8 8.7 8.7 0 0 0-1.7-.53c-.63-.13-1.31-.15-2.09-.25l-.08-.22a5 5 0 0 1 4.57-1.21 5 5 0 0 1 2.22 1.19 10.85 10.85 0 0 1 1.53 1.83 14.55 14.55 0 0 1 1.88 4.07 20.32 20.32 0 0 1 .79 4.27z"/>
        <path class="cls-26" d="M61.93 160.3a10.32 10.32 0 0 0-4.08 3.43 11.4 11.4 0 0 0-.75 1.07c-.24.37-.52.71-.73 1.11s-.5.76-.7 1.17l-.58 1.26c-.2.42-.31.88-.47 1.32s-.32.89-.42 1.35c-.2.93-.5 1.84-.64 2.79s-.37 1.88-.47 2.84-.21 1.93-.33 2.9h-.23c-.06-1-.12-1.95-.15-2.93s0-2 0-3 .19-2 .28-3c.06-.49.2-1 .29-1.47a15 15 0 0 1 .35-1.47 12 12 0 0 1 2.78-5.55 8.87 8.87 0 0 1 1.24-1 6.17 6.17 0 0 1 .7-.42 4.08 4.08 0 0 1 .73-.35 5.11 5.11 0 0 1 3.15-.32z"/>
        <path class="cls-26" d="M43.37 156.2a5.85 5.85 0 0 1 3.58.91 10 10 0 0 1 2.77 2.53 16.33 16.33 0 0 1 2.65 6.73c.12.58.19 1.17.29 1.75a17.43 17.43 0 0 1 .22 1.75l.14 1.75a17.18 17.18 0 0 1 .07 1.75c0 1.17 0 2.33-.07 3.48s-.16 2.31-.26 3.46h-.23c-.09-1.16-.16-2.3-.22-3.45s-.26-2.27-.38-3.4a13.75 13.75 0 0 0-.24-1.69l-.3-1.67c-.08-.56-.25-1.1-.38-1.65s-.27-1.09-.44-1.62a21 21 0 0 0-1.25-3.05L49 163l-.39-.7a13.35 13.35 0 0 0-.77-1.39 11 11 0 0 0-4.46-4.52z"/>
      </g>
      <path class="cls-10" fill="#a59e7f" d="M62.07 239.41l-10.6-11.67 8.92-11.19-8.8-8.65 7.86-9.23-7.6-7.03.82-.89 8.46 7.82-7.89 9.26 8.78 8.62-8.96 11.24 10.61 11.67-10.79 13.29-.94-.76z"/>
      <path class="cls-10" fill="#a59e7f" d="M51.77 227.69l-8.96-11.24 8.78-8.62-7.9-9.26 8.46-7.82.83.89-7.61 7.03 7.87 9.23-8.8 8.65 8.92 11.19-10.6 11.67 10.12 12.48-.94.76-10.78-13.29z"/>
      <path class="cls-11" fill="#b7ac7e" d="M60.87 227.74l-9.42-10.8 8.49-9.1-8.2-9.87 7.37-7.21.85.87-6.57 6.42 8.17 9.84-8.48 9.08 9.36 10.72-9.25 11.83 10.75 12.81-.93.78-11.38-13.56z"/>
      <path class="cls-11" fill="#b7ac7e" d="M51.63 239.52l-9.25-11.83 9.37-10.72-8.48-9.08 8.17-9.84-6.57-6.42.84-.87 7.38 7.21-8.21 9.87 8.5 9.1-9.43 10.8 9.24 11.81-11.38 13.56-.92-.78z"/>
      <g fill="#604e3b">
        <path class="cls-27" d="M51.5 183.77h1.82v78.2H51.5z"/>
        <path class="cls-27" transform="rotate(-3.55 61.57 222.84)" d="M60.75 183.69h1.82v78.35h-1.82z"/>
        <path class="cls-27" transform="rotate(-86.45 43.479 222.87)" d="M4.3 221.96h78.35v1.82H4.3z"/>
      </g>
      <path class="cls-10" fill="#a59e7f" d="M43.02 183.77h18.79v3.03H43.02z"/>
      <path fill="#898162" d="M46.35 181.95h12.12v1.82H46.35z"/>
      <path fill="#666356" d="M50.67 175.28h3.64v6.67h-3.64z"/>
      <path fill="#a8a59a" d="M34.85 260.04H69.1v5.12H34.85z"/>
    </g>
  </g>
  <path class="cls-8" fill="#fff" d="M244.4 172.69h105.27v20.4H244.4z"/>
  <text class="cls-23" x="265.07" y="188.36" font-family="OpenSans-Bold, 'Open Sans',helvetica" font-size="16.32" font-weight="700">
    Probables
  </text>
  <g id="boton4" class="fix-svg-origin hvr hvr-scale" @click="mostrar(4)">
    <circle class="cls-8" cx="223.72" cy="182.89" r="34.84" fill="#fff"/>
    <circle class="cls-24" cx="223.72" cy="182.89" r="32.52" fill="#beeb7b"/>
    <g clip-path="url(#clip-path-4)">
      <path class="cls-32" transform="rotate(-90 223.72 164.76)" fill="#fd4900" d="M221.85 150.11h3.74v29.3h-3.74z"/>
      <path class="cls-33" transform="rotate(-90 223.72 168.19)" fill="#586a6f" d="M222.16 159.77h3.12v16.83h-3.12z"/>
      <path transform="rotate(-90 223.72 175.05)" fill="#3a5965" d="M217.17 171.93h13.09v6.23h-13.09z"/>
      <path transform="rotate(90 223.72 190.94)" fill="#949c9e" d="M215.62 145.08h16.21v91.73h-16.21z"/>
      <path class="cls-33" transform="rotate(90 223.72 190.63)" fill="#586a6f" d="M212.81 180.03h21.82v21.19h-21.82z"/>
      <path class="cls-36" transform="rotate(90 234.94 190.63)" fill="#699d9e" d="M222.16 187.51h25.56v6.23h-25.56z"/>
      <path class="cls-36" transform="rotate(90 212.5 190.63)" fill="#699d9e" d="M199.72 187.51h25.56v6.23h-25.56z"/>
      <circle cx="223.72" cy="196.03" r="12.65" fill="#3ff" opacity=".47"/>
      <path class="cls-38" d="M223.72 210.31A14.28 14.28 0 1 1 238 196a14.29 14.29 0 0 1-14.28 14.31zm0-25.29a11 11 0 1 0 11 11 11 11 0 0 0-11-11.02z" fill="#166c9b"/>
      <path class="cls-38" transform="rotate(-49.4 239.4 208.68)" fill="#166c9b" d="M237.37 201.16h4.08v15.05h-4.08z"/>
    </g>
  </g>
  <path class="cls-8" fill="#fff" d="M420.38 172.69h105.27v20.4H420.38z"/>
  <text class="cls-23" x="441.06" y="188.36" font-family="OpenSans-Bold, 'Open Sans',helvetica" font-size="16.32" font-weight="700">
    Posibles
  </text>
  <g id="boton5" class="fix-svg-origin hvr hvr-scale" @click="mostrar(5)">
    <circle class="cls-8" cx="399.26" cy="183.17" r="34.84" fill="#fff"/>
    <circle class="cls-24" cx="399.26" cy="183.17" r="32.52" fill="#beeb7b"/>
    <g clip-path="url(#clip-path-5)">
      <path class="cls-40" fill="#5792a0" d="M376.41 174.41h45.7v17.14h-45.7z"/>
      <path class="cls-41" fill="#4d8993" d="M368.16 174.41h9.79v43.25h-9.79zM420.38 174.41h9.79v43.25h-9.79z"/>
      <path fill="#3d767c" d="M394.77 163.8h8.98v5.71h-8.98z"/>
      <path class="cls-32" fill="#fd4900" d="M387.02 161.35h24.48v4.08h-24.48z"/>
      <path class="cls-43" fill="#6abfbf" d="M386.61 171.74h25.3v22.85h-25.3z"/>
      <path class="cls-40" fill="#5792a0" d="M391.1 167.88h16.32v4.08H391.1z"/>
      <path d="M393.55 206.23c0-3.15 4.9-9.79 5.71-9.79s5.71 6.64 5.71 9.79a5.71 5.71 0 1 1-11.42 0z" fill="#1e1e1e"/>
    </g>
  </g>
  <g id="boton6" class="fix-svg-origin hvr hvr-scale" @click="mostrar(6)">
    <circle class="cls-8" cx="129.79" cy="265.35" r="34.84" fill="#fff"/>
    <circle class="cls-14" cx="129.79" cy="265.35" r="32.52" fill="#ffe300"/>
    <g clip-path="url(#clip-path-6)">
      <rect x="79.14" y="260.3" width="69.36" height="24.48" rx="5.67" ry="5.67" fill="none" stroke="#40a3a0" stroke-linejoin="round" stroke-width="10"/>
      <path fill="#429694" d="M122.49 243.16h4.08v11.42h-4.08z"/>
      <path fill="#2c6865" d="M119.64 247.24h9.79v8.16h-9.79z"/>
      <circle class="cls-43" cx="124.53" cy="260.3" r="10.61" fill="#6abfbf"/>
      <path class="cls-32" fill="#fd4900" d="M114.74 240.71h19.59v4.08h-19.59z"/>
      <g fill="#398783">
        <path class="cls-49" d="M137.08 254.59h3.26v11.42h-3.26zM108.52 254.59h3.26v11.42h-3.26zM137.08 279.07h3.26v11.42h-3.26z"/>
        <path class="cls-49" transform="rotate(90 148.5 271.72)" d="M146.87 266.01h3.26v11.42h-3.26z"/>
        <path class="cls-49" d="M108.52 279.07h3.26v11.42h-3.26z"/>
      </g>
    </g>
  </g>
  <text class="cls-21" x="171.04" y="271.98" fill="#191919" font-family="OpenSans-Bold, 'Open Sans',helvetica" font-size="20.4" font-weight="700">
    Recursos contingentes
  </text>
  <g id="boton8" class="fix-svg-origin hvr hvr-scale" @click="mostrar(8)">
    <circle class="cls-8" cx="129.79" cy="410.6" r="34.84" fill="#fff"/>
    <circle cx="129.79" cy="410.6" r="32.52" fill="#00dbd7"/>
    <path transform="scale(-1)" fill="#ffe000" d="M-152.23-430.86h7.16v40.8h-7.16z"/>
    <path transform="scale(-1)" fill="#fa0" d="M-142.68-430.85h7.16v31.83h-7.16z"/>
    <path transform="scale(-1)" fill="#ff6d00" d="M-133.13-430.86h7.16v26.11h-7.16z"/>
    <path transform="scale(-1)" fill="#ff3600" d="M-123.59-430.85h7.16v19.59h-7.16z"/>
    <path transform="scale(-1)" fill="red" d="M-114.04-430.85h7.16v14.84h-7.16z"/>
    <path class="cls-56" fill="#0da800" d="M119.53 396.8v3.83l9.71-9.7 1.63 2.45 5.99-5.99 2.89 2.88-9.52 9.51-1.63-2.45-13.15 13.15v-4.32l-7.99 7.42-2.78-2.99z"/>
    <path class="cls-56" fill="#0da800" d="M142.38 384.75l-8.16 1.63 6.53 6.53z"/>
  </g>
  <text class="cls-21" x="171.04" y="417.24" fill="#191919" font-family="OpenSans-Bold, 'Open Sans',helvetica" font-size="20.4" font-weight="700">
    Recursos prospectivos
  </text>
  <text x="253.76" y="113.96" fill="#191919" font-family="OpenSans-Semibold,Open Sans,helvetica" font-size="20.4" font-weight="700">
    Reservas
  </text>
  <g id="boton2" class="fix-svg-origin hvr hvr-scale" @click="mostrar(2)">
    <circle class="cls-8" cx="219.13" cy="107.97" r="27.48" fill="#fff"/>
    <circle class="cls-24" cx="219.13" cy="107.97" r="25.65" fill="#beeb7b"/>
    <g clip-path="url(#clip-path-7)">
      <circle cx="219.13" cy="98.22" r="10.83" fill="#29708c"/>
      <path fill="#77a5a5" d="M208.17 100.91h21.92v56.48h-21.92z"/>
      <path fill="#64939b" d="M218.91 100.91h11.17v56.48h-11.17z"/>
      <g fill="#384f4e">
        <path class="cls-62" d="M206.9 96.69h24.45v4.22H206.9zM206.9 105.97h24.45v.84H206.9zM206.9 111.97h24.45v.84H206.9zM206.9 117.98h24.45v.84H206.9zM206.9 123.98h24.45v.84H206.9zM206.9 129.99h24.45v.84H206.9zM206.9 136h24.45v.84H206.9zM206.9 142h24.45v.84H206.9zM206.9 148.01h24.45v.84H206.9zM206.9 154.02h24.45v.84H206.9z"/>
      </g>
    </g>
  </g>
  <path fill="none" stroke="#81a544" stroke-miterlimit="10" stroke-width="2" d="M16.78 140h505"/>
  <g>
    <foreignObject v-if="vistos[0]" x="182" y="0" width="25px" height="25px">
      <img src="../imagenes_compartidas/ok-bot.png" alt="">
    </foreignObject>
    <foreignObject v-if="vistos[1]" x="207" y="70" width="25px" height="25px">
      <img src="../imagenes_compartidas/ok-bot.png" alt="">
    </foreignObject>
    <foreignObject v-if="vistos[2]" x="40" y="135" width="25px" height="25px">
      <img src="../imagenes_compartidas/ok-bot.png" alt="">
    </foreignObject>
    <foreignObject v-if="vistos[3]" x="210" y="135" width="25px" height="25px">
      <img src="../imagenes_compartidas/ok-bot.png" alt="">
    </foreignObject>
    <foreignObject v-if="vistos[4]" x="388" y="135" width="25px" height="25px">
      <img src="../imagenes_compartidas/ok-bot.png" alt="">
    </foreignObject>
    <foreignObject v-if="vistos[5]" x="117" y="220" width="25px" height="25px">
      <img src="../imagenes_compartidas/ok-bot.png" alt="">
    </foreignObject>
    </foreignObject>
    <foreignObject v-if="vistos[6]" x="120" y="300" width="25px" height="25px">
      <img src="../imagenes_compartidas/ok-bot.png" alt="">
    </foreignObject>
    <foreignObject v-if="vistos[6]" x="120" y="445" width="25px" height="25px">
      <img src="../imagenes_compartidas/ok-bot.png" alt="">
    </foreignObject>
    <foreignObject v-if="vistos[7]" x="117" y="365" width="25px" height="25px">
      <img src="../imagenes_compartidas/ok-bot.png" alt="">
    </foreignObject>
  </g>
</svg>

</template>
<script>
export default {
  data(){
    return {
      vistos: Array(8).fill(false)
    }
  },
  methods: {
    mostrar(id){
      this.$set(this.vistos,id-1,true)
      this.$emit('openModal',id-1)
    }
  },
  watch: {
    vistos: function(newValue){
      if(newValue.every(el=>{return el;})){
        this.$emit('finished')
      }
    }
  }
}
</script>


<style scoped>
svg {
  height: 60vh;
}
  .cls-1{fill:none}.cls-6{stroke:#043;stroke-miterlimit:10;stroke-width:2px}.cls-24{fill:#beeb7b}.cls-14{fill:#ffe300}.cls-6{fill:#e2e2e2}.cls-21{font-size:20.4px}.cls-21,.cls-23{font-family:OpenSans-Bold,'Open Sans',helvetica;font-weight:700}.cls-8{fill:#fff}.cls-10{fill:#a59e7f}.cls-11{fill:#b7ac7e}.cls-12{fill:#ddd19f}.cls-15{fill:#c3cfd1}.cls-17{fill:#a5110e}.cls-18{fill:#d12118}.cls-19{fill:#561111}.cls-20{fill:#282828}.cls-21{fill:#191919}.cls-23{font-size:16.32px}.cls-26{fill:#2d2d2d}.cls-27{fill:#604e3b}.cls-32{fill:#fd4900}.cls-33{fill:#586a6f}.cls-36{fill:#699d9e}.cls-38{fill:#166c9b}.cls-40{fill:#5792a0}.cls-41{fill:#4d8993}.cls-43{fill:#6abfbf}.cls-49{fill:#398783}.cls-56{fill:#0da800}.cls-62{fill:#384f4e}
</style>